import {
  RaviPort,
  RaviPort2,
  youtubeClone,
  education,
  grocery,
  hospital,
  landing,
  shabPort,
  myPort,
  movie,
  crypto,
  music,
  admin,
  landingStory,
  Photography,
} from "../assets";

export const portfolio = [
  {
    id: 1,
    title: "Youtube Clone",
    type: "react",
    desc: "website Build using React and compaitable for Mobile and tablet screen",
    imageUrl: youtubeClone,
    webUrl: "https://youtubemy.netlify.app/",
  },
  {
    id: 2,
    title: "My Portfolio",
    type: "react",
    desc: "website Build using React and compaitable for Mobile and tablet screen",
    imageUrl: myPort,
    webUrl: "https://rohitkumarportfolio.vercel.app/",
  },
  {
    id: 3,
    title: "Crypto Website",
    type: "react",
    desc: "website Build using React and compaitable for Mobile and tablet screen",
    imageUrl: crypto,
    webUrl: "https://myfirstcrypto.netlify.app/",
  },

 
  
  
];
